import { readCookie } from "common/utils/cookie";
import type { UserType } from "../types";

export function isUserLoggedIn(): boolean {
  return Boolean(readCookie("name"));
}

export function getUserType(): UserType {
  return readCookie("name") ? "signed_in" : "guest_user";
}
